import { Edge, EdgeMarker } from "reactflow"
import { VehicleResearchResponse } from "../../../types/vehicle"

export const buildEdges: (vehicles: VehicleResearchResponse[]) => Edge<any>[] = (vehicles: VehicleResearchResponse[]) => {
	const edges: Edge<any>[] = []
	
	const map: (vehicle: VehicleResearchResponse) => Edge<any>[] = (vehicle: VehicleResearchResponse) => {

		const currentEdges: Edge<any>[] = []
		if (vehicle.parentIds.length === 0) return []
		
		for (const parentId of vehicle.parentIds) {
			const parentVehicle = vehicles.find((vehicle: VehicleResearchResponse) => vehicle.id === parentId)
			if (!parentVehicle) continue

			const id = `${parentVehicle.id}-${vehicle.id}`

			const getIsVehicleResearchedOrBought = () => {
				return vehicle.researched || vehicle.bought
			}

			const getIsAtLeastOneParentBoughtAndVehicleIsNotResearched = () => {
				return vehicle.parentIds.some((parentId: number) => {
					const parentVehicle = vehicles.find((vehicle: VehicleResearchResponse) => vehicle.id === parentId)
					if (!parentVehicle) return false
					return parentVehicle.bought && !getIsVehicleResearchedOrBought()
				})
			}

			const getStyle = () => {
				if (!getIsVehicleResearchedOrBought() && !getIsAtLeastOneParentBoughtAndVehicleIsNotResearched()) {
					return { stroke: "#444", strokeWidth: 2, strokeDasharray: '6 10' }
				} else if (!getIsVehicleResearchedOrBought()) {
					return { stroke: "#fff", strokeWidth: 2, strokeDasharray: '6 10' }
				}
				return { stroke: "#fff", strokeWidth: 2 }
			}

			const getEndMarker = () => {
				if (!getIsVehicleResearchedOrBought() && !getIsAtLeastOneParentBoughtAndVehicleIsNotResearched()) {
					return {
						type: 'arrowclosed',
						color: '#444',
						width: 10,
						height: 10
					}
				} else if (!getIsVehicleResearchedOrBought()) {
					return {
						type: 'arrowclosed',
						color: '#fff',
						width: 10,
						height: 10
					}
				}
				return {
					type: 'arrowclosed',
					color: '#fff',
					width: 10,
					height: 10
				}
			}

			currentEdges.push(
				{
					id,
					source: parentVehicle.id.toString(),
					type: "smoothstep",
					target: vehicle.id.toString(),
					animated: false,
					reconnectable: false,
					style: getStyle(),
					markerEnd: getEndMarker() as EdgeMarker
				}
			)
			
		}

		return currentEdges
	}

	vehicles.forEach((vehicle: VehicleResearchResponse) => {
		const edge = map(vehicle)
		if (edge) edges.push(...edge)
	})

	return edges
}
